export const GET_DOWNLOAD_REQUESTS = "GET_DOWNLOAD_REQUESTS";
export const GET_DOWNLOAD_REQUEST_BY_ID = "GET_DOWNLOAD_REQUEST_BY_ID";
export const UPDATE_DOWNLOAD_REQUEST = "UPDATE_DOWNLOAD_REQUEST";
export const DELETE_DOWNLOAD_REQUEST = "DELETE_DOWNLOAD_REQUEST";
export const CREATE_DOWNLOAD_REQUEST = "CREATE_DOWNLOAD_REQUEST";
